export interface SubtitleTrackInfo {
    lang: string;
    url?: string;
    kind: "subtitle";
    id: string;
    enabled?: boolean;
    label: string;
}

export interface AudioTrackInfo {
    language: string;
    label: string;
    id?: string;
}

export interface TrackDiscoveryCallback {
    (tracks: {
        subtitles: SubtitleTrackInfo[];
        audio: AudioTrackInfo[];
    }): void;
}

export interface VideoConfig {
    startPosition?: number;
    autoplay?: boolean;
    subtitles?: any[];
    onCueEnter?: (str: string) => void;
    preferredSubLang?: string;
    drm?:string;
    laUrl?: string;
    onTracksDiscovered?: TrackDiscoveryCallback;
    onLicenseError?: () => void;
}

export interface SourceConfig {
    hls?: string;
    dash?: string;
    progressive?: string;

    drm?: {
        widevine?: {
            LA_URL: string;
        };
        playready?: {
            LA_URL: string;
        };
    };
}

export interface CueEvent {
    type: "cueenter" | "cueexit";
    timestamp: number;
    subtitleId: string;
    start: number;
    end: number;
    text: string;
    html: string;
    vtt: {
        vertical: string;
        align: "start" | "center" | "end";
        size: number;
        line: "auto" | string | number;
        lineAlign: "start" | "center" | "end";
        position: "auto" | string | number;
        positionAlign: "start" | "center" | "end";
        snapToLines: boolean;
    };
}

export const videoPlayerDefaults = {
    debug: false,
    autoplay: true,
    backBufferLength: 10,
    maxBufferLength: 30,
    maxBufferSize: 30
};
